import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomMessage from 'components/common/CustomMessage';
import PageHeader from 'components/common/PageHeader';
import { ToastContent } from 'components/common/Toast';
import { useEffect, useState } from 'react';
import { Card, Spinner } from 'react-bootstrap';
import { FaBell } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { getSearches } from 'redux/searchesSlice';
import ButtonCreate from 'utils/buttons/ButtonCreate';
import AlertList from './AlertList';
import AlertModal from './AlertModal';

const AlertsPage = () => {
  // * States
  const [modalShow, setModalShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const userLogged = useSelector(state => state.login.currentUser);
  const { searches } = useSelector(state => state.searches);

  const dispatch = useDispatch();

  // * Methods
  const callToast = (title, body, time) =>
    toast(<ToastContent title={title} body={body} time={time} />);

  // * Life Cycle
  useEffect(() => {
    if (userLogged) {
      setIsLoading(true);
      dispatch(getSearches(userLogged.id));
    }
  }, [userLogged]);

  useEffect(() => {
    if (searches) {
      setIsLoading(false);
    }
  }, [searches]);

  return (
    <>
      <PageHeader
        title="Alertas"
        description="Cree alertas para conocer los últimos inmuebles publicados dentro del portal CABAPROP."
        className="mb-3 bg-white"
      >
        <ButtonCreate
          className="w-100 w-md-auto"
          text="Nueva alerta"
          variant="primary"
          funcion={() => setModalShow(true)}
        />
      </PageHeader>

      <Card className="bg-white">
        <Card.Header className="d-flex justify-content-between border-bottom">
          <Card.Title className="fw-light d-flex align-items-center gap-2">
            <span className="fs-0">
              <FontAwesomeIcon icon="fa-solid fa-bell" />
            </span>

            <span>Listado de Alertas</span>
          </Card.Title>
        </Card.Header>

        <Card.Body>
          {isLoading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: '80px' }}
            >
              <Spinner
                animation="border"
                style={{
                  color: '#2c7be5'
                }}
              />
            </div>
          ) : searches?.result?.length > 0 ? (
            <AlertList
              callToast={callToast}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
            />
          ) : (
            <CustomMessage
              message="Puede crear alertas personalizadas haciendo click en el botón 'Nueva alerta'."
              title="No hay alertas creadas."
              ReactIcon={FaBell}
            />
          )}
        </Card.Body>
      </Card>
      <AlertModal modalShow={modalShow} setModalShow={setModalShow} />
    </>
  );
};

export default AlertsPage;
